import { create } from 'zustand'

export const usePromoBannerStore = create((set) => ({
  bannerClosed: false,
  closeBanner: () => set({ bannerClosed: true }),
  resetBanner: () => set({ bannerClosed: false }),
}))
